import { CheckCircle, Download, Home, Mail } from "lucide-react";
import { Card } from "../misc/Card";
import { Badge, Button } from "antd";

const SubscriptionSuccess = () => {
  // Mock subscription data
  const subscriptionData = {
    planName: "Premium Business",
    amount: "$49.99",
    billingCycle: "Monthly",
    nextBillingDate: "December 3, 2025",
    transactionId: "TXN-2025-11-03-8X4K9P2M",
    email: "user@example.com",
    subscriptionId: "SUB-PREMIUM-2025-001",
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        {/* Success Icon */}
        <div className="flex justify-center mb-3">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-[green]/40 to-[emerald]/5 rounded-full blur-xl opacity-50" />
            <CheckCircle
              className="w-24 h-24 text-[green] relative z-10"
              strokeWidth={1.5}
            />
          </div>
        </div>

        {/* Main Success Card */}
        <Card className="p-8 shadow-xl border-0 bg-white/80 backdrop-blur-sm">
          <div>
            <div className="text-center mb-8">
              <h1 className="text-[green] text-[20px] mb-2">
                Subscription Activated!
              </h1>
              <p className="text-gray-600">
                Thank you for subscribing. Your payment has been processed
                successfully.
              </p>
            </div>

            {/* Subscription Details */}
            <div className="space-y-6 mb-8">
              <div className="bg-gradient-to-r from-primary/5 to-secondary/5 rounded-lg p-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <p className="text-gray-600 mb-1">Subscription Plan</p>
                    <h2 className="text-gray-900">
                      {subscriptionData.planName}
                    </h2>
                  </div>
                  <Badge className="text-white bg-[green] hover:bg-[green] px-2 py-1 rounded-8">
                    Active
                  </Badge>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-gray-600 mb-1">Amount</p>
                    <p className="text-gray-900">{subscriptionData.amount}</p>
                  </div>
                  <div>
                    <p className="text-gray-600 mb-1">Billing Cycle</p>
                    <p className="text-gray-900">
                      {subscriptionData.billingCycle}
                    </p>
                  </div>
                </div>
              </div>

              {/* <Separator /> */}

              {/* Transaction Details */}
              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Next Billing Date</span>
                  <span className="text-gray-900">
                    {subscriptionData.nextBillingDate}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Transaction ID</span>
                  <span className="text-gray-900 font-mono text-sm">
                    {subscriptionData.transactionId}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Subscription ID</span>
                  <span className="text-gray-900 font-mono text-sm">
                    {subscriptionData.subscriptionId}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Confirmation Sent To</span>
                  <span className="text-gray-900">
                    {subscriptionData.email}
                  </span>
                </div>
              </div>

              {/* <Separator /> */}

              {/* Info Message */}
              <div className="bg-[blue]/5 border border-[blue]/5 rounded-lg p-4 flex gap-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-blue-900 mb-1">Confirmation Email Sent</p>
                  <p className="text-secondary">
                    We've sent a confirmation email with your subscription
                    details and receipt to {subscriptionData.email}
                  </p>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3">
              <Button className="flex-1 bg-primary hover:bg-secondary text-white">
                <Home className="w-4 h-4 mr-2" />
                Go to Dashboard
              </Button>
              <Button className="flex-1">
                <Download className="w-4 h-4 mr-2" />
                Download Receipt
              </Button>
            </div>

            {/* Footer Note */}
            <p className="text-center text-gray-500 mt-6">
              You can manage your subscription anytime from your account
              settings.
            </p>
          </div>
        </Card>

        {/* PayPal Logo Footer */}
        <div className="text-center mt-8">
          <p className="text-gray-500">
            Secured by <span className="text-primary">PayPal</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
